import React, { memo } from 'react'
import { Button } from '@wmgtech/legato'

import { ProductTable } from 'modulesCommon/ProductTable/components'

import { useProductTable } from 'modulesCommon/serviceHooks'

const ProductTableContainer = memo(() => {
  const {
    fields,
    editingRowIdx,
    addProduct,
    handleRowClose,
    handleRowEdit,
    handleAddProduct
  } = useProductTable()

  return (
    <div className="table-container">
      {
        !!fields.length && (
          <ProductTable
            products={fields}
            editingRowIdx={editingRowIdx}
            handleRowClose={handleRowClose}
            handleAddProduct={handleAddProduct}
            handleRowEdit={handleRowEdit}
          />
        )
      }
      <Button
        className="add-product"
        onClick={addProduct}
        label="Add Product"
        containerStyle="outline"
        colorType="secondary-black"
        secondaryIcon="circle-plus"
        disabled={editingRowIdx === fields.length - 1 && !fields[fields.length - 1].isSaved}
      />
    </div>
  )
})

export default ProductTableContainer
